import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Certification } from '../../../models/certification.model';
import { DataTableService } from '../../../modules/UIKit/components/dataTable/dataTable.service';
import { DataTableField } from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import { CertificationService } from '../../../services/certification/certification.service';

@Component({
  selector: 'app-certification',
  templateUrl: './certification.component.html',
  styleUrls: ['./certification.component.css'],
  providers: []
})
export class CertificationComponent implements OnInit {

  selectedCertification: Certification = null;
  certificationListTitles: DataTableField[];
  showDialog = false;
  newDataAvailable = false;
  modalTitle = '';
  labels = {};

  constructor(public srvCertification: CertificationService,
    private srvDataTable: DataTableService,
    private translate: TranslateService) {
    this.translate.get(['certificationList']).subscribe((res) => {

      this.certificationListTitles = [
        { id: 'id', label: '#' },
        { id: 'code', label: res.certificationList.code },
        { id: 'description', label: res.certificationList.description }
      ];

    });
  }

  ngOnInit() {
    this.translate.get([
      'certificationList.add_title',
      'certificationList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['certificationList.add_title'];
      this.labels['edit_title'] = res['certificationList.edit_title'];
    });

    this.srvCertification.getAll().subscribe();
  }

  refresh() {
    this.srvCertification.getAll().subscribe(() => {
      this.newDataAvailable = true;
    });
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.srvCertification.certificationEditing = data == null ? new Certification() : data;
    this.showDialog = true;
  }

  delete (record): void {
    this.srvCertification.delete(record).subscribe( () => {
      this.refresh();
    });
  }


  certificationAdded($event): void {
    this.srvCertification.post($event).subscribe(() => {
      this.srvDataTable.get('dt_certification').showDetail = false;
      this.srvCertification.certificationEditing = null;
      this.refresh();
      this.showDialog = false;
    });
  }

  certificationUpdated($event): void {
    this.srvCertification.put($event).subscribe(() => {
      this.srvDataTable.get('dt_certification').showDetail = false;
      this.srvCertification.certificationEditing = null;
      this.refresh();
      this.showDialog = false;
    })
  }

  onDialogHide () {
    this.srvCertification.certificationEditing = null;
    this.refresh();
    this.showDialog = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/certification/certification.component.ts